import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  clearSessionCurrencyTypeId,
  getSessionCurrencyTypeId,
  setSessionCurrencyTypeId,
} from 'app/api/cookie';
import { CurrencyType } from 'app/constants/currency';

import AccountMenuItem from './AccountMenuItem';

// Local Variables
const sessionCurrencyTypeId = getSessionCurrencyTypeId() ?? null;
const handleSetSessionCurrencyTypeId = (id: null | number) => () => {
  if (id) {
    setSessionCurrencyTypeId(`${id}`);
  } else {
    clearSessionCurrencyTypeId();
  }

  window.location.reload();
};

// Component Definition
const MultiCurrencyMenuItem: FC = () => {
  const { t } = useTranslation('components');

  const currencyTypeOptions: ({
    id: null | string;
    label: string;
    onClick: () => void;
  })[] = [
    {
      id: null,
      label: t('multiCurrency.allCurrencies', 'All'),
      onClick: handleSetSessionCurrencyTypeId(null),
    },
    {
      id: `${CurrencyType.USD}`,
      label: CurrencyType[CurrencyType.USD] ?? 'USD',
      onClick: handleSetSessionCurrencyTypeId(CurrencyType.USD),
    },
    {
      id: `${CurrencyType.CAD}`,
      label: CurrencyType[CurrencyType.CAD] ?? 'CAD',
      onClick: handleSetSessionCurrencyTypeId(CurrencyType.CAD),
    },
  ];

  const selectedCurrency = currencyTypeOptions.find(currencyType => currencyType.id === sessionCurrencyTypeId);

  const selectedCurrencyLabel = selectedCurrency ? ` (${selectedCurrency.label})` : '';

  return (
    <AccountMenuItem
      label={t('multiCurrency.currencyTypeMenu', 'Currency Type{{selectedCurrencyLabel}}', { selectedCurrencyLabel })}
      subItems={currencyTypeOptions}
      subItemSelectedId={sessionCurrencyTypeId}
    />
  );
};

export default MultiCurrencyMenuItem;
